
function SingleChoice({ label, choice, subtitle }) {
  let color = (choice === undefined) ? "white" : (choice) ? "success" : "danger";
  return (
    <div className='row my-2 justify-content-center'>
      <div className='col-6 text-center'>
        <h3>
          {label}
          {subtitle && <small className='text-muted ms-2 fs-6'>({subtitle})</small>}
        </h3>
      </div>
      <span className={`col-3 badge border text-bg-${color}`}>{'\u00A0'}</span>
    </div>
  );
}

function Choice({ choices, bot }) {
  if (!choices || choices.length === 0)
    choices = [undefined, undefined];

  return (
    <div className='card mx-4 col-5'>
      <h4 className='card-title py-2 border-bottom text-center'>Choice</h4>
      <div className='card-body align-items-center'>
        <SingleChoice label='You' choice={choices[0]} />
        <SingleChoice label='Bot' choice={choices[1]} subtitle={bot.name} />
      </div>
    </div>
  );
}

export default Choice;
